import Button from './button';

export default class Success extends Button {
  get buttonVariant() {
    return 'success';
  }
}
